import React from 'react';
import fetcher from '../utils/fetcher';
import {useChekinSDK} from 'context/ChekinSDK';
import {useReservation} from 'context/reservation';

type ContractType = {
  file: string;
};

function useContracts() {
  const {reservationId, getContracts} = useChekinSDK();
  const {data: reservation, housing} = useReservation();

  const [isLoadingContracts, setIsLoadingContracts] = React.useState(false);
  const [isContractsError, setIsContractsError] = React.useState(false);
  const [contracts, setContracts] = React.useState<Array<ContractType>>([]);

  const isContractEnabled = housing?.is_contract_enabled;

  const fetchContracts = React.useCallback(async () => {
    if (!reservationId) {
      return;
    }

    try {
      setIsContractsError(false);
      setIsLoadingContracts(true);

      const data = await fetcher(
        getContracts,
        `housing_sample_id=${reservation?.housing_id}`,
      );
      if (data) {
        setContracts(data);
      }
    } catch (error) {
      setIsContractsError(true);
    } finally {
      setIsLoadingContracts(false);
    }
  }, [reservation, reservationId, getContracts]);

  React.useEffect(() => {
    if (isContractEnabled) {
      fetchContracts();
    }
  }, [fetchContracts, isContractEnabled]);

  return {
    isLoadingContracts,
    isContractsError,
    contracts,
    fetchContracts,
  };
}

export {useContracts};
